export default __webpack_public_path__ + "static/media/Anjan_Poudel.2bc396d2.pdf";